"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var type_configuration_service_1 = require("../../../shared/services/api/type-configuration.service");
var of_1 = require("rxjs/observable/of");
var Observable_1 = require("rxjs/Observable");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var from_1 = require("rxjs/observable/from");
var root_category_provider_service_1 = require("../../../shared/services/api/root-category-provider.service");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var EntitySelectPickerSettingsComponent = /** @class */ (function (_super) {
    __extends(EntitySelectPickerSettingsComponent, _super);
    function EntitySelectPickerSettingsComponent(communicationService, kbService, typeConfigurationService, classifierService, actionService, processService, stateService, rootCategoryProviderService) {
        var _this = _super.call(this, communicationService) || this;
        _this.communicationService = communicationService;
        _this.kbService = kbService;
        _this.typeConfigurationService = typeConfigurationService;
        _this.classifierService = classifierService;
        _this.actionService = actionService;
        _this.processService = processService;
        _this.stateService = stateService;
        _this.rootCategoryProviderService = rootCategoryProviderService;
        _this.FormType = idm_dynamic_layout_interpreter_1.FormType;
        _this.availableMainEntityMetaFields = [];
        _this.selectedTypeIds = [];
        _this.selectedSubTypeIds = [];
        _this.selectedWFStateIds = [];
        _this.selectedDisplayNames = [];
        _this.isReady = false;
        _this._destroy$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(EntitySelectPickerSettingsComponent.prototype, "state", {
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    EntitySelectPickerSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setStateValues();
        this.kbService.getMetaFields(this.category)
            .pipe(operators_1.concatMap(function (metaFields) {
            _this.availableMainEntityMetaFields = metaFields.filter(function (metaField) {
                return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY;
            });
            _this.selectedTargetEntityMetaField = _this.selectedTargetEntityMetaField ?
                _this.findTargetEntityMetaField(_this.availableMainEntityMetaFields) : null;
            if (_this.selectedTargetEntityMetaField) {
                return _this.loadTargetEntityData(_this.selectedTargetEntityMetaField);
            }
            else {
                return of_1.of(new TargetEntityData());
            }
        }))
            .take(1)
            .takeUntil(this._destroy$)
            .subscribe(function (targetEntityData) {
            _this.targetEntity = targetEntityData;
            _this.isReady = true;
        });
    };
    EntitySelectPickerSettingsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    EntitySelectPickerSettingsComponent.prototype.onMainEntityFieldSelect = function (metaField) {
        var _this = this;
        this.selectedTargetEntityMetaField = metaField;
        this.selectedTypeIds = [];
        this.selectedSubTypeIds = [];
        this.selectedWFStateIds = [];
        if (metaField) {
            this.loadTargetEntityData(metaField)
                .takeUntil(this._destroy$)
                .take(1)
                .subscribe(function (targetEntityData) { return _this.targetEntity = targetEntityData; });
        }
        else {
            this.targetEntity = new TargetEntityData();
        }
        this.changeCommunicationSettings();
    };
    EntitySelectPickerSettingsComponent.prototype.changeCommunicationSettings = function () {
        var data = {
            bindings: {},
            state: this.getState(),
            fields: {}
        };
        if (this.selectedTargetEntityMetaField) {
            data.fields['field'] = this.selectedTargetEntityMetaField;
        }
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, data));
    };
    EntitySelectPickerSettingsComponent.prototype.getState = function () {
        return {
            filter: this.getFilter(),
            targetEntityMetaField: this.selectedTargetEntityMetaField,
            targetEntityParentFieldId: this.targetEntity.rootCategoryFieldName,
            typeIds: this.selectedTypeIds,
            subTypeIds: this.selectedSubTypeIds,
            WFStateIds: this.selectedWFStateIds,
            displayFields: this.selectedDisplayNames,
            rootCategoryId: this.targetEntity.rootCategoryId,
            rootCategoryFieldName: this.targetEntity.rootCategoryFieldName,
            hasCreateButton: this.hasCreateButton && !!this.targetEntity.initialWFStateId,
            tooltipSettings: this._tooltipSettings
                ? this._tooltipSettings.toJsonString()
                : undefined,
        };
    };
    EntitySelectPickerSettingsComponent.prototype.setStateValues = function () {
        this.selectedTargetEntityMetaField = this._state['targetEntityMetaField'];
        this.selectedTypeIds = this._state['typeIds'];
        this.selectedSubTypeIds = this._state['subTypeIds'];
        this.selectedWFStateIds = this._state['WFStateIds'];
        this.selectedDisplayNames = this._state['displayFields'] || [];
        this.hasCreateButton = this._state['hasCreateButton'];
        if (this._state['tooltipSettings']) {
            this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(this._state['tooltipSettings']);
        }
    };
    EntitySelectPickerSettingsComponent.prototype.loadTargetEntityData = function (selectedTargetEntityMetaField) {
        var _this = this;
        var targetEntityCategoryName = selectedTargetEntityMetaField.getCompoundCategorySystemName();
        var metaFields$ = this.kbService.getMetaFields(targetEntityCategoryName);
        var types$ = this.typeConfigurationService.getTypedCategoryProperties(targetEntityCategoryName);
        var targetEntityProcess$ = from_1.from(this.processService.getProcessesWithTrackInfo()).pipe(operators_1.concatMap(function (processes) {
            var targetEntityProcess = processes.find(function (process) {
                return process.getCategorySystemName() === targetEntityCategoryName;
            });
            if (targetEntityProcess) {
                return from_1.from(_this.stateService.getStates(targetEntityProcess.getId()))
                    .map(function (states) {
                    return ({
                        initialStateId: targetEntityProcess.getInitialStateId(),
                        states: states
                    });
                });
            }
            else {
                return of_1.of(null);
            }
        }));
        var rootCategoryInfo$ = Observable_1.Observable.zip(this.rootCategoryProviderService.getRootCategoryMetaField(targetEntityCategoryName), this.rootCategoryProviderService.getRootCategoryId(targetEntityCategoryName))
            .map(function (_a) {
            var rootCategoryMetaField = _a[0], rootCategoryName = _a[1];
            return ({ fieldName: rootCategoryMetaField && rootCategoryMetaField.getSystemName(), name: rootCategoryName });
        });
        return Observable_1.Observable.zip(types$, targetEntityProcess$, metaFields$, rootCategoryInfo$)
            .pipe(operators_1.concatMap(function (_a) {
            var entityTypeConfig = _a[0], process = _a[1], metaFields = _a[2], rootCategory = _a[3];
            var targetEntityData = new TargetEntityData;
            targetEntityData.rootCategoryId = rootCategory.name;
            targetEntityData.rootCategoryFieldName = rootCategory.fieldName;
            targetEntityData.WFStateField = metaFields.find(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE; })
                .getSystemName();
            targetEntityData.metaFields = metaFields.filter(function (field) {
                return field.getType() !== idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY &&
                    field.getType() !== idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY &&
                    field.getType() !== idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE &&
                    field.getType() !== idm_kb_service_client_js_1.MetaFieldType.PARENT;
            });
            _this.selectedDisplayNames = _this.selectedDisplayNames && targetEntityData.metaFields.filter(function (field) {
                return _this.selectedDisplayNames.some(function (value) { return field.getSystemName() === value['metaFieldId']['systemName']; });
            });
            if (process && process.states.length) {
                targetEntityData.WFStates = process.states;
                targetEntityData.initialWFStateId = process.initialStateId;
            }
            if (entityTypeConfig) {
                _this.isTypedCategory = true;
                targetEntityData.typeCategoryName = entityTypeConfig.type.category;
                targetEntityData.typeFieldName = entityTypeConfig.type.field;
                targetEntityData.subTypeCategoryName = entityTypeConfig.subType && entityTypeConfig.subType.category;
                targetEntityData.subTypeFieldName = entityTypeConfig.subType && entityTypeConfig.subType.field;
                var typeClassifiers$ = _this.classifierService.loadAllClassifiers(entityTypeConfig.type.category);
                var subTypeClassifiers$ = entityTypeConfig.subType ?
                    _this.classifierService.loadAllClassifiers(entityTypeConfig.subType.category)
                    :
                        of_1.of(null);
                return Observable_1.Observable.zip(typeClassifiers$, subTypeClassifiers$)
                    .map(function (_a) {
                    var types = _a[0], subTypes = _a[1];
                    targetEntityData.types = types.getData();
                    targetEntityData.subTypes = subTypes ? subTypes.getData() : [];
                    targetEntityData.filteredSubTypes = targetEntityData.subTypes.filter(function (subType) {
                        return _this.selectedTypeIds.includes(subType.getProperty(targetEntityData.typeFieldName).value);
                    });
                    return targetEntityData;
                });
            }
            else {
                return of_1.of(targetEntityData);
            }
        }));
    };
    EntitySelectPickerSettingsComponent.prototype.findTargetEntityMetaField = function (mainEntityMetaFields) {
        var _this = this;
        return mainEntityMetaFields.find(function (metaField) {
            return metaField.getSystemName() === _this.selectedTargetEntityMetaField['metaFieldId']['systemName'];
        });
    };
    EntitySelectPickerSettingsComponent.prototype.getFilter = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var filter = { '$and': [] };
        if (this.selectedWFStateIds.length) {
            filter.$and.push((_a = {}, _a[this.targetEntity.WFStateField] = { '$in': this.selectedWFStateIds }, _a));
        }
        if (this.selectedTypeIds.length) {
            if (this.selectedTypeIds.length === 1 && this.selectedSubTypeIds.length === 1) {
                filter.$and.push((_b = {}, _b[this.targetEntity.typeFieldName] = this.selectedSubTypeIds[0], _b), (_c = {}, _c[this.targetEntity.subTypeFieldName] = this.selectedSubTypeIds[0], _c));
            }
            else if (this.selectedSubTypeIds.length) {
                var sortedSubTypesByTypeId_1 = new Map();
                var orFilter_1 = [];
                var selectedSubTypeClassifiers = this.targetEntity.filteredSubTypes
                    .filter(function (subType) { return _this.selectedSubTypeIds.indexOf(subType.getId()) !== -1; });
                selectedSubTypeClassifiers.forEach(function (subTypeClassifier) {
                    var typeId = subTypeClassifier.getProperty(_this.targetEntity.typeFieldName).value;
                    if (sortedSubTypesByTypeId_1.has(typeId)) {
                        sortedSubTypesByTypeId_1.get(typeId).push(subTypeClassifier.getId());
                    }
                    else {
                        sortedSubTypesByTypeId_1.set(typeId, [subTypeClassifier.getId()]);
                    }
                });
                sortedSubTypesByTypeId_1.forEach(function (subTypes, typeId) {
                    var _a, _b;
                    orFilter_1.push({
                        '$and': [
                            (_a = {}, _a[_this.targetEntity.typeFieldName] = typeId, _a),
                            (_b = {}, _b[_this.targetEntity.subTypeFieldName] = { '$in': subTypes }, _b)
                        ]
                    });
                });
                var typesWithNoSelectedSubType = this.selectedTypeIds.filter(function (typeId) {
                    return !sortedSubTypesByTypeId_1.has(typeId);
                });
                if (typesWithNoSelectedSubType.length) {
                    orFilter_1.push((_d = {}, _d[this.targetEntity.typeFieldName] = { '$in': typesWithNoSelectedSubType }, _d));
                }
                filter.$and.push({ '$or': orFilter_1 });
            }
            else {
                filter.$and.push((_e = {}, _e[this.targetEntity.typeFieldName] = { '$in': this.selectedTypeIds }, _e));
            }
        }
        return filter;
    };
    EntitySelectPickerSettingsComponent.prototype.onTypeSelect = function (typeIds) {
        var _this = this;
        this.selectedTypeIds = typeIds;
        this.targetEntity.filteredSubTypes = this.targetEntity.subTypes.filter(function (subType) {
            return typeIds.includes(subType.getProperty(_this.targetEntity.typeFieldName).value);
        });
        if (this.selectedSubTypeIds) {
            this.selectedSubTypeIds = this.selectedSubTypeIds.filter(function (selectedSubTypeId) {
                return _this.targetEntity.filteredSubTypes.some(function (subType) { return subType.getId() === selectedSubTypeId; });
            });
        }
        this.changeCommunicationSettings();
    };
    EntitySelectPickerSettingsComponent.prototype.onSubTypeSelect = function (subTypeIds) {
        this.selectedSubTypeIds = subTypeIds;
        this.changeCommunicationSettings();
    };
    EntitySelectPickerSettingsComponent.prototype.onWfStateSelect = function (WFStateIDs) {
        this.selectedWFStateIds = WFStateIDs;
        this.changeCommunicationSettings();
    };
    EntitySelectPickerSettingsComponent.prototype.onDisplayNameChange = function (systemNames) {
        this.selectedDisplayNames = systemNames;
        this.changeCommunicationSettings();
    };
    EntitySelectPickerSettingsComponent.prototype.onHasCreateButtonChange = function (value) {
        this.hasCreateButton = value;
        this.changeCommunicationSettings();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySelectPickerSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], EntitySelectPickerSettingsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], EntitySelectPickerSettingsComponent.prototype, "controlLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySelectPickerSettingsComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], EntitySelectPickerSettingsComponent.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], EntitySelectPickerSettingsComponent.prototype, "state", null);
    EntitySelectPickerSettingsComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-entity-select-picker-settings',
            template: require('./entity-select-picker-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<ejustice-entity-select-picker-settings\n                    [category]=\"category\"\n                    [state]=\"%{state}\"\n                    [languages]=\"%{languages}\"\n                    [controlLabel]=\"%{controlLabel}\"\n                    [formType]=\"%{formType}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\">\n              </ejustice-entity-select-picker-settings>"
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService, idm_kb_service_client_js_1.KbService,
            type_configuration_service_1.TypeConfigurationService, idm_classifier_service_client_js_1.ClassifierService,
            idm_workflow_service_client_js_1.ActionService, idm_workflow_service_client_js_1.ProcessService, idm_workflow_service_client_js_1.StateService,
            root_category_provider_service_1.RootCategoryProviderService])
    ], EntitySelectPickerSettingsComponent);
    return EntitySelectPickerSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.EntitySelectPickerSettingsComponent = EntitySelectPickerSettingsComponent;
var TargetEntityData = /** @class */ (function () {
    function TargetEntityData() {
        this.WFStates = [];
        this.metaFields = [];
        this.types = [];
        this.subTypes = [];
        this.filteredSubTypes = [];
    }
    return TargetEntityData;
}());
//# sourceMappingURL=entity-select-picker-settings.component.js.map